import React from 'react';
import { Accordion } from '@gumtree/ui-library';

import { StyledItemsListContainer } from './frame-accordion.style';
import { EXPANDED_FILTERS } from '../../shared/constants';
import { trackFilterOpenChange } from '../../shared/filters-utils';

const FrameAccordion = ({
    filterKey,
    title,
    children,
}: {
    filterKey?: string;
    title: string;
    children: React.ReactNode;
}) => {
    return (
        <Accordion
            title={title}
            isDefaultOpened={filterKey ? EXPANDED_FILTERS.includes(filterKey) : false}
            onOpenChange={(open: boolean) => {
                if (filterKey) {
                    trackFilterOpenChange(open, filterKey);
                }
            }}
        >
            <StyledItemsListContainer>{children}</StyledItemsListContainer>
        </Accordion>
    );
};

export default FrameAccordion;
